<template>
  <v-container class="fill-height" style="opacity: 0.94" fluid>
    <v-sheet elevation="1" rounded width="100%" class="mt-16 mb-8">
      <v-row justify="space-between" class="px-2">
        <v-col cols="12" md="6">
          <v-text-field label="Search" prepend-icon="mdi-magnify" v-model="search"></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-row no-gutters justify="end" class="py-3">
            <v-btn-toggle class="mr-2">
              <v-menu :close-on-content-click="false" offset-y :transition="false">
                <template #activator="{ on, attrs }">
                  <v-btn large value="left" v-bind="attrs" v-on="on" disabled>
                    <v-icon>mdi-filter-variant</v-icon>
                    <span class="hidden-sm-and-down">Filter</span>
                  </v-btn>
                </template>

                <v-card>
                  <v-list>
                    <!-- <v-list-item v-for="filter in filters" :key="filter.prop">
                      <v-list-item-action>
                        <v-checkbox v-model="filter.active" />
                      </v-list-item-action>
                      <v-list-item-content style="cursor: default">
                        <v-list-item-title>{{ filter.text }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item> -->
                  </v-list>
                </v-card>
              </v-menu>

              <v-menu :close-on-content-click="false" offset-y :transition="false">
                <template #activator="{ on, attrs }">
                  <v-btn large value="center" v-bind="attrs" v-on="on">
                    <v-icon>mdi-view-column-outline</v-icon>
                    <span class="hidden-sm-and-down">Columns</span>
                  </v-btn>
                </template>

                <v-card min-width="205px">
                  <v-list>
                    <v-list-item class="text-left" link v-for="item in headers" :key="item.value">
                      <v-list-item-action>
                        <v-checkbox v-model="item.active" :disabled="item.fixed" />
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>{{ item.text }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-menu>

              <v-menu :close-on-content-click="false" offset-y :transition="false">
                <template #activator="{ on, attrs }">
                  <v-btn large value="right" v-bind="attrs" v-on="on">
                    <v-icon>mdi-swap-vertical</v-icon>
                    <span class="hidden-sm-and-down">Sort</span>
                  </v-btn>
                </template>

                <v-card min-width="205px">
                  <v-card-text>
                    <v-subheader>Group By</v-subheader>
                    <v-radio-group v-model="groupedAs" column>
                      <v-radio label="None" :value="null"></v-radio>
                      <v-radio label="Constellation" value="constellation"></v-radio>
                      <v-radio label="Magnitude" value="magnitude"></v-radio>
                      <v-radio label="Brightness" value="brightness"></v-radio>
                      <v-radio label="Variant" value="variant"></v-radio>
                      <v-radio label="Visibility" value="checked"></v-radio>
                    </v-radio-group>
                  </v-card-text>
                </v-card>
              </v-menu>
            </v-btn-toggle>
            <new-star-dialog></new-star-dialog>
          </v-row>
        </v-col>
      </v-row>
      <v-data-table
        dense
        :headers="activeHeaders"
        height="65vh"
        fixed-header
        :items="stars"
        :options.sync="options"
        :server-items-length="totalStars"
        :loading="loading"
        :items-per-page="50"
        :footer-props="{
          'items-per-page-options': [50, 100, 150],
        }"
        loading-text="Loading... Please wait"
        :group-by="groupedAs"
      >
        <template v-slot:[`group.header`]="{ group, headers, toggle, isOpen }">
          <td :colspan="headers.length" class="text-left">
            <v-btn @click="toggle" x-small icon :ref="group">
              <v-icon v-if="isOpen">mdi-plus</v-icon>
              <v-icon v-else>mdi-minus</v-icon>
            </v-btn>
            <span class="mx-5 font-weight-bold">{{ group }}</span>
          </td>
        </template>

        <template v-slot:[`item.controls`]="{ item }">
          <v-row>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  target="_blank"
                  :href="softwareUrl + item.parsed_name"
                >
                  <v-icon>mdi-search-web</v-icon>
                </v-btn>
              </template>
              <span>
                View in software
                <v-icon small>mdi-open-in-new</v-icon>
              </span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn disabled icon color="lime darken-3" v-bind="attrs" v-on="on">
                  <v-icon>mdi-chart-timeline-variant-shimmer</v-icon>
                </v-btn>
              </template>
              <span>Generate star chart</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  color="amber darken-3"
                  v-bind="attrs"
                  v-on="on"
                  @click="openEditDialog(item)"
                >
                  <v-icon>mdi-circle-edit-outline</v-icon>
                </v-btn>
              </template>
              <span>Edit nickname</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  disabled
                  color="red darken-3"
                  v-bind="attrs"
                  v-on="on"
                  @click="deleteSso(item.short_name)"
                >
                  <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
              </template>
              <span>Delete star from catalogue</span>
            </v-tooltip>
          </v-row>
        </template>
        <template v-slot:[`item.checked`]="{ item }">
          <v-switch
            inset
            hide-details
            class="mt-0"
            color="success"
            dense
            :disabled="!isAdmin"
            v-model="item.checked"
            @click="toggle(item)"
          ></v-switch>
        </template>
        <template v-slot:no-results>
          <v-alert :value="true" color="error" append-icon="mdi-warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
        </template>
      </v-data-table>

      <v-dialog v-model="editDialog.show" max-width="420px">
        <v-card>
          <v-card-title>Edit Nickname</v-card-title>
          <v-card-text class="text-left">
            <div class="mb-2">{{ editDialog.star && editDialog.star.name }}</div>
            <v-text-field
              v-model="editDialog.internalName"
              label="Internal Name / Nickname"
              counter="60"
              clearable
              autofocus
              @keyup.enter="saveInternalName"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="editDialog.show = false">Cancel</v-btn>
            <v-btn color="primary" text :loading="editDialog.saving" @click="saveInternalName">
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-sheet>
  </v-container>
</template>

<script>
  import api from '@/assets/js/api_helper'
  import NewStarDialog from '../components/NewStarDialog.vue'
  import {
    deleteSkySource,
    toggleSkySourceVisibility,
    updateSkySourceInternalName,
  } from '../services/skySourceService'
  import { isUserAdmin } from '../services/authService'

  export default {
    props: {
      source: String,
    },
    data() {
      return {
        search: '',
        softwareUrl: 'https://software.space-registry.org/skysource/',
        headers: [
          {
            text: 'Original Name',
            value: 'name',
            active: true,
            fixed: true,
          },
          {
            text: 'Internal Name / Nickname',
            value: 'nick_name',
            active: true,
          },
          { text: 'Constellation', value: 'constellation', active: true },
          { text: 'Magnitude', value: 'magnitude', active: true },
          { text: 'Variant', value: 'variant', active: true },
          { text: 'Brightness', value: 'brightness', active: true },
          { text: 'Visibility', value: 'checked', active: true },
          { text: 'Actions', value: 'controls', sortable: false, active: true },
        ],
        stars: [],
        totalStars: 0,
        loading: false,
        options: {},
        searchTimer: null,
        groupedAs: null,
        isAdmin: false,
        editDialog: {
          show: false,
          star: null,
          internalName: '',
          saving: false,
        },
      }
    },
    methods: {
      fetchStars: async function () {
        this.loading = true
        try {
          const { page, itemsPerPage, sortBy, sortDesc } = this.options
          const { data } = await api.getStarCatalogue({
            limit: itemsPerPage,
            offset: (page - 1) * itemsPerPage,
            search: this.search || undefined,
            sortBy: sortBy && sortBy[0],
            sortDesc: sortDesc && sortDesc[0],
          })
          this.stars = data.items
          this.totalStars = data.total
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      deleteSso: async function (skysource) {
        console.log(skysource)
        const yes = confirm('Are you sure you want to delete?')

        if (yes) {
          try {
            await deleteSkySource(skysource)
            const idx = this.stars.findIndex((sso) => sso.short_name === skysource)
            if (idx != -1) this.stars.splice(idx, 1)
          } catch (error) {
            console.log(error)
          }
        }
      },
      openEditDialog: function (star) {
        this.editDialog.star = star
        this.editDialog.internalName = star.nick_name || ''
        this.editDialog.show = true
      },
      saveInternalName: async function () {
        const { star, internalName } = this.editDialog

        this.editDialog.saving = true
        try {
          const { data } = await updateSkySourceInternalName(
            star.short_name,
            (internalName || '').trim()
          )
          star.nick_name = data.nick_name
          this.editDialog.show = false
        } catch (error) {
          console.log(error)
        } finally {
          this.editDialog.saving = false
        }
      },
      toggle: async function (skysource) {
        const { short_name, checked } = skysource

        try {
          const { data } = await toggleSkySourceVisibility(short_name, checked)
          skysource.checked = data.checked
        } catch (error) {
          skysource.checked = !checked
          console.log(error)
        }
      },
    },
    computed: {
      activeHeaders() {
        return this.headers.filter((header) => header.active)
      },
    },
    watch: {
      options: {
        handler() {
          this.fetchStars()
        },
        deep: true,
      },
      search: function () {
        clearTimeout(this.searchTimer)
        this.searchTimer = setTimeout(() => {
          if (this.options.page !== 1) this.options.page = 1
          else this.fetchStars()
        }, 400)
      },
      activeHeaders: function () {
        localStorage.setItem('catalogue-headers', JSON.stringify(this.headers))
      },
      groupedAs: function () {
        if (this.groupedAs === null) return localStorage.removeItem('catalogue-group')
        localStorage.setItem('catalogue-group', this.groupedAs)
      },
    },
    mounted: async function () {
      const headers = localStorage.getItem('catalogue-headers')
      if (headers) this.headers = JSON.parse(headers)
      this.groupedAs = localStorage.getItem('catalogue-group') || null
      // The data table syncs its options on mount, which triggers the
      // options watcher and performs the initial fetch.
      this.isAdmin = await isUserAdmin()
    },
    components: { NewStarDialog },
  }
</script>

<style></style>
